Base = App.loadClass 'core::Services/MapLayers/Base'

# Used by Rx Mapping to display a combined layer set.
# This is just like an instance of the Base maplayer class,
# but with a different source url. So that's what we're
# doing; creating an Base instance, and setting the url
exports.register = (module) ->
    module.factory 'Core.Services.MapLayers.CombinedLayers', [
        '$http', 'Core.Services.Map', '$q', (args...) ->
            return {
                new: () ->
                    service = new exports.CombinedLayers(args...)
                    service.geojson = null

                    return service
            }
    ]


class exports.CombinedLayers extends Base
    url: 'backend/grower/layers/planting-rx/get-cropped-polygons'

    propertyTable: (ft, layer) =>
        if ft.properties?
            props = ft.properties

            info = "
                <table class='table table-condensed margin-top-22'>
            "

            info += @_property 'Area (ac)', props.acres # TODO: support hectares

            if props.productivity
                # TODO: only include "Avg" if there was more than one?
                info += @_property 'Avg Yield', props.productivity

            if props.musym
                info += @_property 'Soil Type', props.musym

            if props.soil_yield
                info += @_property 'Soil Yield', props.soil_yield

            if props.irrigated
                info += @_property 'Irrigated', ''

            info += '</table>'

        layer.bindPopup(info)

    _property: (key, val) =>
        return "<tr>
            <td><strong>#{key}</strong></td>
            <td>#{val}</td>
        </tr>"
